export default {
    _prefix: "FormEditor",
    labels: {
        endOfForm: "End of Form",
        addQuestionGroup: "Add Question Group",
        publishedForm: "This form has been published.",
        disabledForm: "This form has been disabled",
        publishedFormWithDate: "This form was published on {{#date}}{{/date}}.",
        disabledFormWithDate: "This form was disabled on {{#date}}{{/date}}.",
        modifiedDate: "Last Modified:",
        questionLimitReached: (maxQuestionCount: {
            maxQuestionCount: number;
        }) => "Maximum question limit at {{maxQuestionCount}} reached.",
        questionLimitReachedTooltip: (maxQuestionCount: {
            maxQuestionCount: number;
        }) =>
            "A form may not contain more than {{maxQuestionCount}} questions. Please delete one before adding another.",
    },
    markdown: {
        help: "Standard markdown syntax is supported",
        hint: "[link text](link) # large text #  {{#Strong}} **bold**{{/Strong}}",
        labels: {
            section: {
                header: "Header Section",
                footer: "Footer Section",
            },
            header: "Header Content",
            footer: "Footer Content",
            removeMarkDownEditor: "Remove",
            addMarkdownEditor: {
                header: "Add Header",
                footer: "Add Footer",
            },
        },
    },
    FormNameEditor: {
        errors: {
            duplicate: "Cannot use duplicate form name.",
            empty: "Form name cannot be blank.",
            lengthyName: (maxFormNameLength: { maxFormNameLength: number }) =>
                "Form name may have at most {{maxFormNameLength}} characters.",
        },
        labels: {
            title: {
                evaluation: "Evaluation Form Editor",
                automatedEvaluation: "Automated Evaluation Form Editor",
                survey: "Survey Form Editor",
            },
            defaultFormNameText: {
                evaluation: "[Evaluation Form Name Here]",
                survey: "[Survey Name Here]",
            },
            evaluation: "Evaluation Form Name",
            survey: "Survey Form Name",
            invalidInput: "Invalid Input",
            icon: "Evaluation Form Performance",
        },
    },
    Form: {
        errors: {
            minimumScorableQuestions:
                "Should have at least one scorable question.",
        },
    },
};
